import React, { useState, useEffect } from 'react'
import HorizontalSeparator from '../HorizontalSeparator/HorizontalSeparator'
import ReplySection from '../ReplySection/ReplySection'
import AddReply from '../AddReply/AddReply'
import { supabase } from '../../supabaseClient'

const CommentTile = ({ comment }) => {
    const [replyIcon, setReplyIcon] = useState("fa-chevron-down")
    const [showReply, setShowReply] = useState(false)
    const [showAddReply, setShowAddReply] = useState(false)
    const [replies, setReplies] = useState([])
    const [replyCount, setReplyCount] = useState(comment?.reply_count || 0)

    const handleShowReply = () => {
        if (showReply) {
            setReplyIcon("fa-chevron-down")
            setShowReply(false)
        } else {
            setReplyIcon("fa-chevron-up")
            setShowReply(true)
        }
    }

    const handleShowAddReply = () => {
        setShowAddReply(v => !v)
    }

    const getRepliesArray = async () => {
        if (!comment || !comment.key) return

        try {
            const { data, error } = await supabase
                .from('replies')
                .select('*')
                .eq('comment_id', comment.key)
                .order('id', { ascending: true })

            if (error) throw error

            if (!data || data.length === 0) {
                setReplies([])
                setReplyCount(0)
                return
            }

            // Get usernames for replies
            const userIds = [...new Set(data.map(r => r.user_id).filter(Boolean))]
            let profileMap = {}

            if (userIds.length > 0) {
                const { data: profiles } = await supabase
                    .from('profiles')
                    .select('user_id, username')
                    .in('user_id', userIds)

                if (profiles) {
                    profiles.forEach(p => {
                        profileMap[p.user_id] = p.username
                    })
                }
            }

            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

            const formattedReplies = data.map(reply => {
                const dateObj = new Date(reply.date || reply.created_at)
                const dateString = `${dateObj.getDate()} ${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}`

                return {
                    key: reply.id,
                    username: profileMap[reply.user_id] || reply.username || 'User',
                    date: dateString,
                    text: reply.text
                }
            })

            setReplies(formattedReplies)
            setReplyCount(formattedReplies.length)
        } catch (e) {
            console.error('Error fetching replies:', e.message)
        }
    }

    useEffect(() => {
        if (comment) {
            getRepliesArray()
        }
    }, [comment])

    return (
        <div className="pl-0 sm:pl-4 mt-4">
            <div className="flex items-center">
                <div className="text-sm font-semibold mr-4">
                    {comment.username}
                </div>
                <div className="text-xs text-gray-500">
                    {comment.date}
                </div>
            </div>
            <div className="py-1 text-sm text-gray-800">
                {comment.text}
            </div>
            <div className="flex text-sm py-1 items-center">
                {/* HIDES THE BUTTON IF REPLY COUNT IS 0 */}
                {replyCount > 0 && (
                    <button className="text-blue-600 hover:underline flex items-center mr-4" onClick={handleShowReply}>
                        <span>{`${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`}</span>
                        <i className={`fa-sharp fa-solid ${replyIcon} pl-2 text-xs`}></i>
                    </button>
                )}
                
                <button 
                    className="border px-3 py-0.5 rounded-lg bg-gray-200 ring-2 ring-gray-300 hover:bg-gray-300 transition-colors text-xs" 
                    onClick={handleShowAddReply}
                >
                    Reply
                </button>
            </div>
            {
                showAddReply ? <AddReply comment={comment} setShowAddReply={setShowAddReply} getRepliesArray={getRepliesArray} /> : null
            }
            {
                showReply && replyCount > 0 ? <ReplySection comment={comment} replies={replies} setReplies={setReplies} /> : null
            }
            <div className="mt-3">
                <HorizontalSeparator />
            </div>
        </div>
    )
}

export default CommentTile
